import Activity from './activity';

export default Activity;



// WEBPACK FOOTER //
// ./src/components/elements/activity/index.js